<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />

    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import AcademicYearServices from '@/services/api/academicyear.api';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';
export default {
  name: 'ReferralCountStatus',
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    model: {
      search: {
        filters: {
          academicYear: null,
          caat: null,
          referralType: null,
        },
        collections: {
          academicYears: [],
          caats: [],
          referralTypes: [],
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Informe Conteo de Referidos por Estatus',
        icon: 'fa-solid fa-list font-22 ',
        routes: [
          'Inicio',
          'Asistencia Tecnológica',
          'Informe Conteo de Referidos por Estatus',
        ],
      };
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          class: 'col-md-4',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
        },
        {
          name: 'caat',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'CAAT',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.model.search.collections.caats,
          value: this.model.search.filters.caat,
        },
        {
          name: 'referralType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Tipo de Referido',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.model.search.collections.referralTypes,
          value: this.model.search.filters.referralType,
        },
      ];
    },
  },
  async mounted() {
    await this.getInitialFilters();
  },
  methods: {
    async getReferralTypes() {
      const { data } = await referralAndEquipmentsservice.getReferralTypes();
      this.model.search.collections.referralTypes = data;
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (isValid) {
        this.process();
      }
    },
    async getInitialFilters() {
      await this.getReferralTypes();
      await this.getCaats();
      this.model.search.collections.academicYears = (
        await AcademicYearServices.getCurrentYearAcademicYears()
      ).data;
    },
    async getCaats() {
      const { data } = await referralAndEquipmentsservice.getCaats();
      this.model.search.collections.caats = data;
    },
    async process() {
      await ReportServices.getReport('referralcountstatus', {
        academicYearId: this.model.search.filters.academicYear?.id,
        caatId: this.model.search.filters.caat?.id,
        referralTypeId: this.model.search.filters.referralType?.id,
      }).then((res) => DocumentServices.Download(res.data));
    },
  },
};
</script>

<style lang="scss" scoped></style>
